import { baseApi } from '@shared/api/baseApi'

export interface TelegramAuthGenerateResponse {
  token: string
  link: string
  expires_at: string
}

export type TelegramAuthTokenStatus = 'created' | 'confirmed'

export interface TelegramAuthCheckResponse {
  status: TelegramAuthTokenStatus
  expires_at: string
}

export interface TelegramAuthConfirmResponse {
  already_confirmed: boolean
  expires_at: string
}

export interface TelegramAuthUseResponse {
  user: {
    user_id: number
    name: string
  }
}

/**
 * Создаёт handshake-токен для web-авторизации через Telegram.
 * Бэк ставит httpOnly cookie tg_auth_hs и отдаёт ссылку на бота.
 */
export const generateTelegramAuthToken = async (): Promise<TelegramAuthGenerateResponse> => {
  const { data } = await baseApi.post<TelegramAuthGenerateResponse>(
    '/api/web-auth/telegram/generate-token'
  )
  return data
}

/**
 * Проверяет статус токена. 404 означает, что токен истёк или уже использован.
 * @param token - Полный токен с префиксом telegram_auth_
 */
export const checkTelegramAuthToken = async (token: string): Promise<TelegramAuthCheckResponse> => {
  const { data } = await baseApi.get<TelegramAuthCheckResponse>(
    '/api/web-auth/telegram/check-token',
    { params: { token } }
  )
  return data
}

/**
 * Подтверждает токен с TG-стороны (требует Init-Data + привязанный email).
 * @param token - Полный токен с префиксом telegram_auth_
 */
export const confirmTelegramAuthToken = async (token: string): Promise<TelegramAuthConfirmResponse> => {
  const { data } = await baseApi.post<TelegramAuthConfirmResponse>(
    '/api/web-auth/telegram/confirm-token',
    { token }
  )
  return data
}

/**
 * Активирует сессию на web-стороне (устанавливает sid cookie).
 * Handshake cookie должна лететь автоматически (withCredentials).
 * @param token - Полный токен с префиксом telegram_auth_
 */
export const useTelegramAuthToken = async (token: string): Promise<TelegramAuthUseResponse> => {
  const { data } = await baseApi.post<TelegramAuthUseResponse>(
    '/api/web-auth/telegram/use-token',
    { token }
  )
  return data
}
